<template>
  <div>
  <Header />
  <div class="table-section-trainee">
    <div class="logbook-name">
    <table class="logbook-name-table">
      <tbody>
        <tr>
      <td class="logbookName">{{ logbookName }}</td>
      <td>
         <button @click="openTraineeProgressModal" class="traineepdfButton">Progress</button>
      </td>
      <td v-if="ENABLE_LOGBOOK_RULES">
        <button @click="openLogbookRulesModal" class="traineepdfButton">Logbook Rules</button>
      </td>
      <!-- <td style="border:none;"><button class="traineepdfButton" @click="openSignatureModal">Signature</button>
      </td> -->
      <td>
        <button class="back-button" @click="goBack">Back</button>
      </td>
      <!-- <td> <button @click="createPDFReport" style="font-size: 18px;" class="traineepdfButton">Download PDF</button></td> -->
        </tr>
      </tbody>
    </table>
    </div>
    <div class="signoff-kpi" :class="{ 'signoff-kpi-complete': signOffPassRateMet }">
      <span class="signoff-kpi-label">Tasks Remaining:</span>
      <span class="signoff-kpi-value">{{ signOffRemaining }} / {{ signOffTotal }}</span>
    </div>
    <div class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 10px;  margin-top: 10px;">
      <div
        v-if="currentEvaluation"
        :class="evaluationStatusClass"
      >
        {{ evaluationStatusText }}
      </div>
    </div>
    <div v-if="isDisabled" class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
      <div class="expired-box">
        This logbook is locked. Tasks can no longer be signed off.
      </div>
    </div>
    <div class="ins-table-footer">
      <div class="ins-per-page-group">
        <span>Rows per page:</span>
        <select v-model="perPage" class="ins-per-page-select">
          <option v-for="opt in perPageOptions" :key="opt" :value="opt">{{ opt }}</option>
        </select>
      </div>
      <div class="ins-pagination-right">
        <div class="ins-pagination-info">
          Showing {{ filteredTasks.length === 0 ? 0 : startIndex + 1 }}-{{ endIndex }} of {{ filteredTasks.length }} Tasks
        </div>
        <div v-if="perPage !== 'All' && totalPages > 1" class="ins-pagination-container">
          <Pagination :total-pages="totalPages" :per-page="perPage" :current-page="currentPage"
            @page-change="onPageChange" />
        </div>
      </div>
    </div>
    <div class="table-scroll-wrapper">
    <table class="data-table-trainee">
      <thead>
        <tr>
          <th class="MO">ATA
            <select id="chapter-filter" v-model="selectedChapter">
              <option value="All">All</option>
              <option v-for="chapter in uniqueChapters" :key="chapter" :value="chapter">{{ chapter }}</option>
            </select>
          </th>
          <th class="task-no">Task No</th>
          <!-- <th class="category">Category
            <select v-model="selectedCategory">
              <option value="All">All</option>
              <option v-for="category in uniquecategories" :key="category" :value="category">{{ category }}</option>
            </select>
          </th> -->
          <th class="MO">MT/AT<br>
            <select id="manob-filter" v-model="selectedMO">
              <option value="All">All</option>
              <option v-for="mo in uniqueMOs" :key="mo" :value="mo">{{ mo }}</option>
            </select>
          </th>
          <th id="scope-filter" class="scope">Scope
            <select v-model="selectedscope">
              <option value="All">All</option>
              <option v-for="scope in uniquescopes" :key="scope" :value="scope">{{ scope }}</option>
            </select>
          </th>
          <!--<th class="sect-id">Sect ID</th>-->
          <th class="description">Description</th>
          <th class="reference">Reference</th>
          <th v-if="ENABLE_SKILL_P1_P2" class="scope" style="border-right: 2px solid black;">Skill
              <select v-model="selectedSkill">
                <option value="All">All</option>
                <option v-for="skill in uniqueskills" :key="skill" :value="skill">{{ skill }}</option>
              </select>
            </th>
          <th v-else class="scope" style="border-right: 2px solid black;">Category
              <select v-model="selectedCategory">
                <option value="All">All</option>
                <option v-for="category in uniquecategories" :key="category" :value="category">{{ category }}</option>
              </select>
            </th>
          <th v-if="SHOW_AC_REG" class="ac_reg">A/C Reg</th>
          <!-- <th class="ac_reg">Jobcard No</th> -->
            <th class="P1" style="text-align: center;">Classroom</th>
            <th class="P1" style="text-align: center; padding-left: 10px; padding-right: 10px; border-right: 2px solid black;">Aircraft</th>
            <th class="P1" style="border-left: 2px solid black; border-right: 2px solid black;">Assigned By</th>
            <th class="completed">Date</th>
            <!--<th class="level"> Level
            <select id="level-filter" v-model="selectedLevel">
              <option value="All">All</option>
              <option v-for="level in uniqueLevels" :key="level" :value="level">{{ level }}</option>
            </select>
          </th>
          <th class="isexam">Is Exam</th>
         <th class="isexam">Task Enabled</th> -->
          <th class="completed">Completed
            <select id="completed-filter" v-model="selectedCompleted" style="width:100%">
              <option value="All tasks">All tasks</option>
              <option value="not enabled tasks">Unassigned</option>
              <option value="enabled tasks">Assigned</option>
              <option value="completed tasks">Signed Off</option>
              <option value="enabled and incomplete tasks">Not Signed Off</option>
              <!-- <option id="examinable" value="examinable tasks">Assessment tasks</option> -->
            </select>
          </th>
          <th class="inssign" style="border-right: 2px solid black;">Inst. Sign Off
            <select id="ins-so-filter" v-model="selectedSignOff" style="width:100%">
              <option value="All tasks">All tasks</option>
              <option value="signed off tasks">Signed Off</option>
              <option value="not signed off tasks">Not Signed Off</option>
            </select>
          </th>
          <!-- <th class="inssign" style="width: 8%">Inst. Stamp</th> -->
          <th class="trainee_notes">My Notes
            <select v-model="selectedPrivateNotes">
              <option value="All">All</option>
              <option value="has note">Has Note</option>
              <option value="no note">No Note</option>
            </select>
          </th>
          <th class="trainee_insnotes">Inst Notes
            <select v-model="selectedPublicNotes">
              <option value="All">All</option>
              <option value="has note">Has Note</option>
              <option value="no note">No Note</option>
            </select>
          </th>
          <!-- <th class="assess" style="width: 1%;">Assess</th> -->
        </tr>
      </thead>

      <tbody>
        <template v-for="(group, chaptNo) in paginatedTasks" :key="chaptNo">
    <!-- Row for the Chapter Name -->
    <tr class="chapter-row">
      <td colspan="100%" class="chapter-name-cell">{{ group.name }}</td>
    </tr>
        <tr v-for="(task, index) in group.tasks" :key="index">
          <td>{{ task.chapt_no }}</td>
          <td @click="openTaskLongFormModal(task)" style="color: blue; text-decoration: underline;">{{ task.task_no }}
          </td>
          <!-- <td>{{ task.reference }}</td> -->
          <!-- <td>{{ task.category }}</td> -->
          <td>{{ task.manob }}</td>
          <td>{{ task.scope }}</td>
          <td @click="openTaskLongFormModal(task)" style="cursor: pointer;">
            <div class="description-cell" :style="{ color: task.is_submitted === 3 ? 'green' : 'blue' }">
              <template v-for="(part, index) in splitReference(task.description)" :key="index">
                {{ part }}<br v-if="index < splitReference(task.description).length - 1" />
              </template>
            </div>
          </td>
          <td>
            <template v-for="(part, index) in splitReference(task.reference)" :key="index">
              {{ part }}<br v-if="index < splitReference(task.reference).length - 1" />
            </template>
          </td>
          <td style="border-right: 2px solid black;">{{ ENABLE_SKILL_P1_P2 ? task.skill : task.category }}</td>
          <td v-if="SHOW_AC_REG">
            <div class="ac-reg-container">
              <input v-if="task.enabled" type="text" v-model="task.ac_reg" @focus="handleFocus(task)"
                @input="filterACRegSuggestions(task.ac_reg, task)" @blur="handleBlur(task)"
                @mousedown="onInputFieldMouseDown" @change="updateTaskACReg(task)" class="ac-reg-input"
                :disabled="task.completed || !task.enabled" />
              <ul v-if="filteredACReg.length && showSuggestions && activeTaskId === task.task_id"
                class="ac-reg-suggestions">
                <li v-for="(suggestion, index) in filteredACReg" :key="index"
                  @click="selectACRegSuggestion(task, suggestion)">
                  {{ suggestion }}
                </li>
              </ul>
            </div>
          </td>
          <!-- <td>
            <div class="jobcard-no-container">
              <input v-if="task.enabled" type="text" v-model="task.jobcard_no" @focus="handleJobcardFocus(task)"
                @input="filterJobcardNoSuggestions(task.jobcard_no, task)" @blur="handleJobcardBlur(task)"
                @mousedown="onJobcardInputFieldMouseDown" @change="updateTaskJobcardNo(task)" class="jobcard-no-input"
                :disabled="task.ins_so || !task.enabled" />->
              <ul v-if="filteredJobcardNo.length && showJobcardSuggestions && activeJobcardTaskId === task.task_id"
                class="jobcard-no-suggestions">
                <li v-for="(suggestion, index) in filteredJobcardNo" :key="index"
                  @click="selectJobcardNoSuggestion(task, suggestion)">
                  {{ suggestion }}
                </li>
              </ul>
            </div>
          </td> -->
              <td style="text-align: center;">
                <input style="width: 15px; height: 15px; margin-left: 10px; margin-right: 10px;" v-if="task.enabled"
                  type="checkbox" id="P1" name="P1" v-model="task.entry_P1" disabled
                  @change="handleP1P2Change(task, 'P1')" />
              </td>
              <td style="text-align: center; border-right: 2px solid black;">
                <input style="width: 15px; height: 15px; margin-left: 10px; margin-right: 10px;" v-if="task.enabled"
                  type="checkbox" id="P2" name="P2" v-model="task.entry_P2" disabled
                  @change="handleP1P2Change(task, 'P2')" />
              </td>
              <td v-if="task.enabled" style="border-left: 2px solid black; border-right: 2px solid black;">
                <b>{{ task.instructor_enabled_name || 'Unknown' }}</b> <br>
              </td>
              <td v-else style="border-left: 2px solid black; border-right: 2px solid black;">
                <div></div>
              </td>
              <td v-if="task.enabled">
                <div>{{ task.selected_date?.split(' ')[0] || '' }}</div>
              </td>
              <td v-else>
                <div></div>
              </td>
          <!--<td>{{ task.sect_id }}</td>
          <td>{{ task.level }}</td>
          <td>{{ task.is_exam }}</td>
          <td>{{ task.enabled }}</td> -->
          <td>
            <div v-if="task.completed || isDisabled" style="padding-right: 20px;">
              <!-- {{ task.completed?.split(' ')[0] || '' }} -->
              <div v-if="task.t_signature_id" class="signature-container" style="max-height: 40px;">
                <img :src="findSignatureUrl(task.t_signature_id)" class="signature-image" alt="Signature">
              </div>
            </div>
            <div v-else>
              <button class="trainee_signoff" @click.prevent="confirmSignOff(task)" :class="{ 'disabled-signoff': !task.enabled }">SIGN
                OFF</button>
              <div v-if="!task.ins_so && task.is_revoked === 1 && !task.completed">
                <button class="instructor_signoff-view-revoke" @click.prevent="openRevokeSignOffModal(task)">View Revoke</button>
              </div>
            </div>
          </td>
          <td style="border-right: 2px solid black;">
            <div v-if="task.ins_so">
                <b>{{ task.instructor_name }}</b> <br>
                <!-- <b>{{ task.instructor_license }}</b> -->
              <!-- {{ task.ins_so.split(' ')[0] }} -->
              <div v-if="task.ins_signature_id" class="signature-container" style="max-height: 40px;">
                <img :src="findInstSignatureUrl(task.ins_signature_id)" class="signature-image" alt="Signature">
              </div>
            </div>
          </td>
          <td>
            <div>
              <button class="notesButton" @click="openEditor(task.logbookentry_id, false)">
                <font-awesome-icon icon="sticky-note" title="Add a note for this task. Only you can view this note."
                  :class="{
                    'icon-green': hasPrivateNote(task),
                    'icon-grey': !hasPrivateNote(task)
                  }" />
              </button>
            </div>
          </td>
          <td>
            <button class="notesButton" @click="openEditor(task.logbookentry_id, true)">
              <font-awesome-icon icon="eye" title="View the instructors note on this task."
                :class="{
                  'icon-green': hasPublicNote(task),
                  'icon-grey': !hasPublicNote(task)
                }" />
            </button>
          </td>
          <!-- <td>
            <div v-if="task.is_assessed">
              <a style="text-decoration: underline; color: blue; cursor: pointer;">View Results</a>
            </div>
          </td> -->
        </tr>
        </template>
        <tr v-if="paginatedTasks.length === 0">
          <td colspan="100" style="text-align: center;">No Matching Tasks</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div class="evaluationSection">
      <button v-if="ENABLE_ASSESSMENT" class="evaluationButton" @click="openChooseAssessmentModal()" :disabled="isDisabled">Task Assessment</button>
      <!-- <button class="addSigButton" @click="addSigToTasks(true)" :disabled="isDisabled">Add Signature to Tasks</button> -->
      <button class="evaluationButton" @click="openChooseEvaluationModal()">
        Evaluation Sheet</button>
    </div>
  </div>
    <QuillEditor v-if="showQuillEditor" :logbookEntryId="currentLogbookEntryId" :logbookId="logbookId" :is-disabled="locked" userRole="trainee" :noteType="noteType" @close="closeQuillEditor">
    </QuillEditor>
    <ChooseAssessmentModal v-if="showChooseAssessmentModal" :logbook-id="parseInt(logbookId)" :trainee="trainee" :instructors="instructors"
      :merged-tasks="mergedTasks" :logbook="logbook" @close="closeChooseAssessmentModal"></ChooseAssessmentModal>
    <task-assessment-modal v-if="showTaskAssessmentModal" :trainee="trainee" :tasks-count="MTCount"
      :completed-tasks="completedMTCount || 0" :taskAssessmentId="taskAssessmentId" :logbook-id="logbookId"
      :fetched-data="fetchedTaskAssessmentData" :attemptNo="attemptNo" :selectedTask="selectedTask"
      @close="closeTaskAssessmentModal"></task-assessment-modal>
    <TaskLongFormModal v-if="showTaskLongFormModal" :task-id="currentTaskId" :logbook-id="logbookId"
      :merged-tasks="mergedTasks" :chapters="chapters" @close="closeTaskLongFormModal"></TaskLongFormModal>
    <TraineeProgressModal v-if="showTraineeProgressModal" :logbook-id="logbookId" :traineeId="traineeId" :merged-tasks="mergedTasks" :passRate="currentProduct.pass_rate ?? 50"
      @close="closeTraineeProgressModal"></TraineeProgressModal>
    <LogbookRulesModal v-if="showLogbookRulesModal"
      @close="closeLogbookRulesModal"></LogbookRulesModal>
    <choose-evaluation-modal v-if="showChooseEvaluationModal" :propTasks="mergedTasks" :tasks-count="tasksCount" :completed-tasks="tasksCompleted" :logbook-id="logbookId" :trainee="trainee" :passRate="currentProduct.pass_rate ?? 50"
      :locked="locked" @close="closeChooseEvaluationModal"></choose-evaluation-modal>
    <signature-modal v-if="showSignatureModal" role="trainee" @close="closeSignatureModal"></signature-modal>
    <RevokeSignOffModal v-if="showRevokeSignOffModal" :task-id="currentTaskId" :logbook-id="logbookId" :logbookentryId="logbookentryId" :instructorId="instructorId" :signOff="signOff" @close="closeRevokeSignOffModal"></RevokeSignOffModal>
    <ChooseSignOffDateModal v-if="showChooseSignOffDateModal" :task-id="currentTaskId" :logbook-id="logbookId"
    :logbookentryId="logbookentryId" :signOffType="signOffType"
    @signOffDateSelected="handleSignOffDateSelected"
    @close="closeChooseSignOffDateModal">
  </ChooseSignOffDateModal>
  </div>
</template>

<script>
import Header from '../Examiner/Header.vue';
import axios from 'axios';
import './TraineeLogbook.css';
import QuillEditor from '@/components/notes/Note.vue';
import Pagination from '@/components/Examiner/TablePagination.vue';
import ChooseAssessmentModal from './TraineeChooseTaskAssessmentModal.vue';
import TaskAssessmentModal from '@/components/Trainee/TraineeTaskAssessmentModal.vue';
import TaskLongFormModal from '@/components/Trainee/TaskLongFormModal.vue';
import TraineeProgressModal from '@/components/Trainee/TraineeProgressModal.vue';
import LogbookRulesModal from '@/components/Trainee/LogbookRulesModal.vue';
import ChooseEvaluationModal from '@/components/Trainee/TraineeChooseEvaluationModal.vue';
import SignatureModal from '@/components/Examiner/SignatureModal.vue';
import RevokeSignOffModal from '@/components/Trainee/TraineeRevokeSignOffModal.vue';
import ChooseSignOffDateModal from '@/components/Instructor/ChooseSignOffDateModal.vue';
import { ENABLE_ASSESSMENT as ENABLE_ASSESSMENT_FLAG, ENABLE_SKILL_P1_P2, SHOW_AC_REG, ENABLE_LOGBOOK_RULES } from '@/config/featureFlags';


export default {
  name: 'TraineeLogbook',
  components: {
    Header,
    QuillEditor,
    TaskAssessmentModal,
    TaskLongFormModal,
    TraineeProgressModal,
    LogbookRulesModal,
    ChooseEvaluationModal,
    Pagination,
    SignatureModal,
    ChooseAssessmentModal,
    RevokeSignOffModal,
    ChooseSignOffDateModal,
  },
  data() {
    return {
      user_id: null,
      logbooks: [],
      logbook: {},
      tasks: [],
      trainee: [],
      logbookName: '',
      productId: localStorage.getItem('productId') || null,
      currentProduct: JSON.parse(localStorage.getItem('currentProduct')) || {},
      logbookId: localStorage.getItem('logbook_id'),
      traineeId: parseInt(localStorage.getItem('user_id')),
      mergedTasks: [],
      editorContent: '',
      showQuillEditor: false,
      showTaskAssessmentModal: false,
      showTaskLongFormModal: false,
      showTraineeProgressModal: false,
      showLogbookRulesModal: false,
      showChooseEvaluationModal: false,
      showSignatureModal: false,
      pendingSignOffTaskId: null,
      showRevokeSignOffModal: false,
      notes: [],
      notesContent: '',
      noteType: '',
      currentTaskId: null,
      selectedMO: 'All',
      selectedCompleted: 'All tasks',
      selectedLevel: 'All',
      selectedscope: 'All',
      selectedSkill: 'All',
      selectedChapter: 'All',
      selectedCategory: 'All',
      selectedisexam: 'All',
      selectedSignOff: 'All tasks',
      selectedPublicNotes: 'All',
      selectedPrivateNotes: 'All',
      offlineTasks: [],
      isSyncing: false,
      isOffline: !navigator.onLine,
      filteredTasksLength: 0,
      currentPage: 1,
      perPage: 25,
      perPageOptions: [10, 25, 50, 100, 'All'],
      customColor: 'rgb(218, 248, 252, 0.7)',
      MTCount: '',
      completedMTCount: '',
      signatureId: '',
      instSignatureId: '',
      signatureUrl: null,
      instructorSignatureUrl: null,
      instructorSignatures: {},
      signatures: [],
      fetchedTaskAssessmentData: [],
      taskAssessmentId: null,
      showChooseAssessmentModal: false,
      acRegList: [],  // Predefined A/C Regs for autofill suggestions
      filteredACReg: [],
      jobcardNoList: [],
      filteredJobcardNo: [],
      activeTaskId: null,
      activeJobcardTaskId: null,
      isSwitchingFocus: false,
      isSwitchingJobcardFocus: false,
      refreshInterval: null,
      isUnmounted: false,
      chapters: [],
      logbookentryId: '',
      instructors: [],
      instructor: [],
      showChooseSignOffDateModal: false,
      signOffType: 'single',
      locked: null,
      trainee_evaluations: [],
      logbookEntries: [],
      lastKnownUpdate: null,
      isCheckingForUpdates: false,
    };
  },
  watch: {
    selectedMO(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.(); // Optional if this method exists
      }
    },
    selectedChapter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedScope(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedSkill(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedCompleted(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedSignOff(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedPublicNotes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedPrivateNotes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
      }
    },
  },
  computed: {
    ENABLE_ASSESSMENT() {
      return ENABLE_ASSESSMENT_FLAG;
    },
    ENABLE_SKILL_P1_P2() {
      return ENABLE_SKILL_P1_P2;
    },
    SHOW_AC_REG() {
      return SHOW_AC_REG;
    },
    ENABLE_LOGBOOK_RULES() {
      return ENABLE_LOGBOOK_RULES;
    },
    filteredTasks() {
      return this.mergedTasks.filter(task => {
        //this.currentPage = 1;
        const moMatches = this.selectedMO === 'All' || task.manob === this.selectedMO;
        const completedMatches =
          this.selectedCompleted === 'All tasks' ||
          (this.selectedCompleted === 'completed tasks' && task.completed) ||
          (this.selectedCompleted === 'not completed tasks' && !task.completed) ||
          (this.selectedCompleted === 'enabled tasks' && task.enabled) ||
          (this.selectedCompleted === 'not enabled tasks' && !task.enabled) ||
          (this.selectedCompleted === 'enabled and incomplete tasks' && (task.enabled && !task.completed)) ||
          (this.selectedCompleted === 'examinable tasks' && task.is_exam) ||
          (this.selectedCompleted === 'signed off no signature' && task.completed && !task.t_signature_id);
        const SignedOffMatches =
          this.selectedSignOff === 'All tasks' ||
          (this.selectedSignOff === 'signed off tasks' && task.ins_so) ||
          (this.selectedSignOff === 'not signed off tasks' && !task.ins_so && task.enabled);
        
        const publicNotesMatches =
          this.selectedPublicNotes === 'All' ||
          (this.selectedPublicNotes === 'has note' && this.hasPublicNote(task)) ||
          (this.selectedPublicNotes === 'no note' && !this.hasPublicNote(task));

        const privateNotesMatches =
          this.selectedPrivateNotes === 'All' ||
          (this.selectedPrivateNotes === 'has note' && this.hasPrivateNote(task)) ||
          (this.selectedPrivateNotes === 'no note' && !this.hasPrivateNote(task));
        
          const levelMatches = this.selectedLevel === 'All' || task.level === parseInt(this.selectedLevel);
        const scopeMatches = this.selectedscope === 'All' || task.scope === this.selectedscope;
        const skillMatches = this.selectedSkill === 'All' || task.skill === this.selectedSkill;
        const chapterMatches = this.selectedChapter === 'All' || task.chapt_no === this.selectedChapter;
        const categoryMatches = this.selectedCategory === 'All' || task.category === this.selectedCategory;
        const isexamMatches = this.selectedisexam === 'All' || task.is_exam === this.selectedisexam;
        return moMatches && completedMatches && levelMatches && SignedOffMatches && scopeMatches && skillMatches && chapterMatches && categoryMatches && isexamMatches && publicNotesMatches && privateNotesMatches;
      });
    },
    groupedTasks() {
      return Object.entries(
        this.filteredTasks.reduce((groups, task) => {
          const chapterName = this.getChapterName(task.chapt_no);
          if (!groups[task.chapt_no]) {
            groups[task.chapt_no] = { name: chapterName, tasks: [] };
          }
          groups[task.chapt_no].tasks.push(task);
          return groups;
        }, {})
      )
        .map(([chaptNo, group]) => ({
          chaptNo,
          ...group,
        }))
        .sort((a, b) => parseInt(a.chaptNo, 10) - parseInt(b.chaptNo, 10)); // Sort numerically by chapter number
    },
    paginatedTasks() {
      const start = this.startIndex;
      const end = this.endIndex;

      const sortedFilteredTasks = [...this.filteredTasks].sort((a, b) => {
        const chapA = parseInt(a.chapt_no, 10);
        const chapB = parseInt(b.chapt_no, 10);
        const taskA = parseInt(a.task_no, 10);
        const taskB = parseInt(b.task_no, 10);

        if (chapA !== chapB) {
          return chapA - chapB;
        }
        return taskA - taskB;
      });

      const paginatedFilteredTasks = sortedFilteredTasks.slice(start, end);

      return Object.entries(
        paginatedFilteredTasks.reduce((groups, task) => {
          const chapterName = this.getChapterName(task.chapt_no);
          if (!groups[task.chapt_no]) {
            groups[task.chapt_no] = { name: chapterName, tasks: [] };
          }
          groups[task.chapt_no].tasks.push(task);
          return groups;
        }, {})
      )
        .map(([chaptNo, group]) => ({
          chaptNo,
          name: group.name,
          tasks: group.tasks.sort((a, b) => parseInt(a.task_no, 10) - parseInt(b.task_no, 10)),
        }))
        .sort((a, b) => parseInt(a.chaptNo, 10) - parseInt(b.chaptNo, 10));
    },
    uniqueChapters() {
      const chapters = this.tasks.map(task => task.chapt_no);
      return [...new Set(chapters)]; // This will remove any duplicates and return unique values.
    },
    uniqueMOs() {
      const MOs = this.tasks.map(task => task.manob);
      return [...new Set(MOs)];
    },
    uniqueLevels() {
      const levels = this.tasks.map(task => task.level);
      return [...new Set(levels)];
    },
    uniquescopes() {
      const scopes = this.tasks.map(task => task.scope);
      return [...new Set(scopes)];
    },
    uniqueskills() {
      const skills = this.tasks.map(task => task.skill);
      return [...new Set(skills)];
    },
    uniquecategories() {
      const categories = this.tasks.map(task => task.category);
      return [...new Set(categories)];
    },
    uniqueisexam() {
      const isexams = this.tasks.map(task => task.is_exam);
      return [...new Set(isexams)];
    },
    uniqueACRegList() {
      if (!this.mergedTasks) return [];
      // Collect ac_reg values from tasks, remove empty/null, and ensure uniqueness
      const acRegList = this.mergedTasks
        .map(task => task.ac_reg) // Extract ac_reg from each task
        .filter(ac_reg => ac_reg) // Remove any undefined or empty values
        .filter((ac_reg, index, self) => self.indexOf(ac_reg) === index); // Ensure uniqueness

      console.log('acRegList');
      console.log(acRegList);
      return acRegList;
    },
    uniqueJobcardNoList() {
      if (!this.mergedTasks) return [];
      // Collect ac_reg values from tasks, remove empty/null, and ensure uniqueness
      const jobcardNoList = this.mergedTasks
        .map(task => task.jobcard_no)
        .filter(jobcard_no => jobcard_no)
        .filter((jobcard_no, index, self) => self.indexOf(jobcard_no) === index); // Ensure uniqueness

      console.log('jobcardNoList');
      console.log(jobcardNoList);
      return jobcardNoList;
    },
    totalPages() {
      if (this.perPage === 'All') return 1;
      return Math.ceil(this.filteredTasks.length / this.perPage);
    },
    startIndex() {
      if (this.perPage === 'All') return 0;
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      if (this.perPage === 'All') return this.filteredTasks.length;
      const end = this.startIndex + this.perPage;
      return end < this.filteredTasks.length ? end : this.filteredTasks.length;
    },
    isDisabled() {
      return this.locked === 1;
    },
    continuousEvaluation() {
      return this.trainee_evaluations.find(e => e.evaluation_type === 'continuous') || null;
    },
    remedialEvaluation() {
      return this.trainee_evaluations.find(e => e.evaluation_type === 'remedial') || null;
    },
    currentEvaluation() {
      const continuous = this.continuousEvaluation;
      const remedial = this.remedialEvaluation;

      // If remedial exists but is still draft/in progress, do not show it to trainee.
      // Fall back to the continuous evaluation instead.
      if (remedial) {
        if (remedial.is_submitted === 1 || remedial.is_submitted === 2) {
          return remedial;
        }
        if (remedial.is_submitted === 0) {
          return continuous || null;
        }
      }

      return continuous || null;
    },
    evaluationStatusClass() {
      const evaluation = this.currentEvaluation;
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) {
        return 'pending-box';
      }

      if (evaluation.is_submitted === 1) {
        return 'pending-box';
      }

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'success-box';
        }

        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'expired-box';
        }

        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'success-box';
        }

        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'expired-box';
        }

        return 'success-box';
      }

      return 'pending-box';
    },
    evaluationStatusText() {
      const evaluation = this.currentEvaluation;
      if (!evaluation) return 'No evaluation started';

      if (evaluation.is_submitted === 0) return 'No evaluation started';
      if (evaluation.is_submitted === 1) return 'Evaluation awaiting trainee signature';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'Continuous evaluation passed';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'Continuous evaluation result: remedial';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'Remedial evaluation passed';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'Remedial evaluation failed';
        }
        return 'Evaluation signed by trainee';
      }
      return 'Evaluation status unknown';
    },
    signOffTotal() {
      return this.mergedTasks.filter(t => t.manob === 'MT' && t.task_status !== 'na').length;
    },
    signOffRemaining() {
      return this.mergedTasks.filter(t => t.manob === 'MT' && t.task_status !== 'na' && !t.ins_so).length;
    },
    signOffPassRateMet() {
      const mtTasks = this.mergedTasks.filter(t => t.manob === 'MT' && t.task_status !== 'na');
      if (mtTasks.length === 0) return false;
      const passRate = this.currentProduct.pass_rate ?? 50;
      const signedPercent = (mtTasks.filter(t => t.ins_so).length / mtTasks.length) * 100;
      return signedPercent >= passRate;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'TraineeHome' });
    },
    hasPublicNote(task) {
      return task.notes?.some(n => n.type === 'public' &&
        n.content?.trim() !== '' && n.content?.trim() !== '<p><br></p>') || false;
    },
    hasPrivateNote(task) {
      return task.notes?.some(n => n.type === 'private' && n.role === 'instructor' &&
        n.content?.trim() !== '' && n.content?.trim() !== '<p><br></p>') || false;
    },
    async handleP1P2Change(task, changed) {
      // Ensure mutual exclusivity
      if (changed === 'P1' && task.entry_P1) {
        task.entry_P2 = false;
      } else if (changed === 'P2' && task.entry_P2) {
        task.entry_P1 = false;
      }

      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const logbookId = this.logbookId;

        await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
          P1: task.entry_P1 ? 1 : 0,
          P2: task.entry_P2 ? 1 : 0,
        }, { headers });

        console.log(`P1/P2 updated for task ${task.task_id}`);
      } catch (error) {
        console.error('Failed to update P1/P2:', error);
      }
    },
    findSelectedSignatureForUser(userId) {
      return this.signatures.find(sig => sig.user_id === userId && sig.is_selected && sig.role === 'trainee') || null;
    },
    getChapterName(chapt_no) {
      const chapter = this.chapters.find((ch) => ch.chapt_no === chapt_no);
      return chapter ? `Chapter ${chapt_no}: ${chapter.name}` : `Chapter ${chapt_no}`;
    },
    splitReference(value) {
      if (!value) return [''];
      return String(value).split('\\');
    },
    getACRegValue(task) {
    return task.ac_reg || task.initial_ac_reg || ''; // Use ac_reg if available, otherwise fallback to initial_ac_reg
  },
    filterACRegSuggestions(input, currentTask) {
      // Get the current task's ac_reg to exclude from suggestions
      const currentACReg = currentTask.ac_reg;

      if (input) {
        // Filter based on the input text if there is any
        this.filteredACReg = this.uniqueACRegList.filter(reg =>
          reg.toLowerCase().includes(input.toLowerCase()) &&
          reg !== currentACReg // Exclude the current task's ac_reg
        );
      } else {
        // If there's no input, show the entire list excluding the current ac_reg
        this.filteredACReg = this.uniqueACRegList.filter(reg => reg !== currentACReg);
      }

      this.showSuggestions = this.filteredACReg.length > 0; // Show suggestions only if there are any
    },
    selectACRegSuggestion(task, suggestion) {
      task.ac_reg = suggestion;
      console.log('task.ac_reg');
      console.log(task.ac_reg);
      this.showSuggestions = false;
      this.activeTaskId = null;  // Reset active task after selection
      this.updateTaskACReg(task);  // Call the function after selecting a suggestion
    },
    setActiveTask(taskId) {
      this.activeTaskId = taskId;
      const currentTask = this.mergedTasks.find(task => task.task_id === taskId);
      this.filterACRegSuggestions('', currentTask);
    },
    handleBlur(task) {
      if (!this.isSwitchingFocus) {
        setTimeout(() => {
          this.showSuggestions = false;
          this.activeTaskId = null;
          this.updateTaskACReg(task);
        }, 100); // 100ms delay to allow click event to complete
      }
    },
    handleFocus(task) {
      this.isSwitchingFocus = false; // Reset the flag when focusing
      this.setActiveTask(task.task_id);
    },
    onInputFieldMouseDown() {
      this.isSwitchingFocus = true; // Set the flag when switching focus
      setTimeout(() => {
        this.isSwitchingFocus = false; // Reset the flag after a short delay
      }, 100);
    },
    async updateTaskACReg(task) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const logbookId = this.logbookId;
        await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
          ac_reg: task.ac_reg
        }, { headers });

        console.log('AC Reg updated successfully');
      } catch (error) {
        console.error('Error updating or creating AC Reg:', error);
      }
    },
    filterJobcardNoSuggestions(input, currentTask) {
      const currentJobcardNo = currentTask.jobcard_no;

      if (input) {
        // Filter based on the input text if there is any
        this.filteredJobcardNo = this.uniqueJobcardNoList.filter(jobcardNo =>
          jobcardNo.toLowerCase().includes(input.toLowerCase()) &&
          jobcardNo !== currentJobcardNo // Exclude the current task's jobcard_no
        );
      } else {
        // If there's no input, show the entire list excluding the current jobcard_no
        this.filteredJobcardNo = this.uniqueJobcardNoList.filter(jobcardNo => jobcardNo !== currentJobcardNo);
      }

      this.showJobcardSuggestions = this.filteredJobcardNo.length > 0; // Show suggestions only if there are any
    },
    selectJobcardNoSuggestion(task, suggestion) {
      task.jobcard_no = suggestion;
      console.log('task.jobcard_no');
      console.log(task.jobcard_no);
      this.showJobcardSuggestions = false;
      this.activeJobcardTaskId = null;  // Reset active task after selection
      this.updateTaskJobcardNo(task);  // Call the function after selecting a suggestion
    },
    setActiveJobcardTask(taskId) {
      this.activeJobcardTaskId = taskId;
      const currentTask = this.mergedTasks.find(task => task.task_id === taskId);
      this.filterJobcardNoSuggestions('', currentTask); // Filter suggestions for this task
    },
    handleJobcardBlur(task) {
      if (!this.isSwitchingJobcardFocus) {
        setTimeout(() => {
          this.showJobcardSuggestions = false; // Hide suggestions after blur
          this.activeJobcardTaskId = null;
          this.updateTaskJobcardNo(task); // Update the jobcard_no when losing focus
        }, 100); // 100ms delay to allow click event to complete
      }
    },
    handleJobcardFocus(task) {
      this.isSwitchingJobcardFocus = false; // Reset the flag when focusing
      this.setActiveJobcardTask(task.task_id); // Set the active task and filter jobcard no
    },
    onJobcardInputFieldMouseDown() {
      this.isSwitchingJobcardFocus = true; // Set the flag when switching focus
      setTimeout(() => {
        this.isSwitchingJobcardFocus = false; // Reset the flag after a short delay
      }, 100);
    },
    async updateTaskJobcardNo(task) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const logbookId = this.logbookId;
        const response = await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
          jobcard_no: task.jobcard_no
        }, { headers });

        console.log(response);
        console.log('Jobcard Number updated successfully');
      } catch (error) {
        console.error('Error updating Jobcard No:', error);
      }
    },
    async addSigToTasks(manual = false) {
      try {
        const logbookId = this.$route.params.logbookId;
        const userId = parseInt(localStorage.getItem('user_id'));

        // Reuse signatures already loaded
        const selectedSig = this.findSelectedSignatureForUser(userId);

        // Filter tasks that need signature
        const filteredSigTasks = this.mergedTasks.filter(task => {
          return task.completed !== null && task.t_signature_id === null &&
            task.trainee_id === userId;
        });

        console.log('selectedSignature', selectedSig);

        if (manual === true) {
          if (!selectedSig) {
            alert('You must add a signature to your profile before adding a signature to tasks.\n\nReturn to the trainee home page to add or upload a signature')
            return;
          }
          if (filteredSigTasks.length === 0) {
            alert(`All signed off tasks already have a signature`)
            return;
          }
          const proceed = confirm(
            `This will add the saved signature to ${filteredSigTasks.length} tasks.\n\nDo you wish to continue?`
          );
          if (!proceed) {
            return; // user cancelled → stop here
          }
        } else {
          if (filteredSigTasks.length === 0) {
            return;
          }
          const proceed = confirm(
            `Would you also like to add this signature to ${filteredSigTasks.length} additional tasks?`
          );
          if (!proceed) {
            return; // user cancelled → stop here
          }
        }

        // Create an array of tasks to update
        const tasksToUpdate = filteredSigTasks.map(task => ({
          logbook_id: parseInt(logbookId),
          task_id: parseInt(task.task_id),
          t_signature_id: selectedSig?.id || null,
        }));

        if (tasksToUpdate.length === 0) {
          console.log('No tasks require signature.');
          return;
        }

        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Make an Axios POST request to the batchUpdate API endpoint
        const response = await axios.post('/api/logbookentry/batch-update', {
          logbook_entries: tasksToUpdate
        }, { headers });

        console.log("Success in updating logbook entries:", response);

        // Update the affected rows immediately in place - no refetch needed
        filteredSigTasks.forEach(task => {
          task.t_signature_id = selectedSig?.id || null;
        });

      } catch (error) {
        console.error('Error updating logbook entries:', error);
        alert('Failed to add the signature to the other tasks. Please try again.');
      }
    },
    findSignatureUrl(signatureId) {
      const signature = this.signatures.find(sig => sig.id === signatureId);
      if (signature && signature.user_image) {
        return `data:image/jpeg;base64,${signature.user_image}`;
      } else {
        return null;
      }
    },
    findInstSignatureUrl(instSignatureId) {
      const signature = this.signatures.find(sig => sig.id === instSignatureId);
      if (signature && signature.user_image) {
        return `data:image/jpeg;base64,${signature.user_image}`;
      } else {
        return null;
      }
    },
        openChooseSignOffDateModal(task, type) {
      this.signOffType = type;
        // Single task sign-off
        this.currentTask = task;
        this.currentTaskId = task.task_id;
        this.logbookentryId = task.logbookentry_id;
      this.showChooseSignOffDateModal = true;
    },
    closeChooseSignOffDateModal() {
      this.showChooseSignOffDateModal = false;
      this.fetchData();
    },
    async handleSignOffDateSelected({ taskId, selectedDate }) {
      const task = this.logbookEntries.find(t => t.task_id === taskId);
      if (!task) return;
      const dateObj = new Date(selectedDate);
      await this.setTimestamp(task, dateObj);
      this.showChooseSignOffDateModal = false;
    },
    async setTimestamp(task, selectedDate = new Date()) {
      const formattedDate = this.formatDate(selectedDate);
      const logbookId = this.$route.params.logbookId;
      const userId = localStorage.getItem('user_id');
      const selectedSig = this.findSelectedSignatureForUser(parseInt(userId));
      console.log('selectedSig', selectedSig);

      // Remember previous state so we can roll back if the request fails
      const previousCompleted = task.completed;
      const previousSignatureId = task.t_signature_id;
      const previousReadOnly = task.isReadOnly;

      // Optimistic update - reflect the sign-off in the UI immediately,
      // no refetch of the whole logbook required.
      task.completed = formattedDate;
      task.isReadOnly = true;
      if (selectedSig) {
        task.t_signature_id = selectedSig.id;
      }

      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
          completed: formattedDate,
          t_signature_id: selectedSig?.id || null,
          P1: task.entry_P1,
          P2: task.entry_P2
        }, { headers });
        console.log("success in updating logbook entry:", response);
        this.noteOwnChange(response.data?.updated_at);

        // Offer to stamp the same signature onto other completed tasks that
        // are still missing one. This reuses in-memory data - no extra fetch.
        if (selectedSig) {
          this.addSigToTasks();
        }
      } catch (error) {
        console.error("Error updating logbook entry:", error);
        // Roll back the optimistic update since the server call failed
        task.completed = previousCompleted;
        task.t_signature_id = previousSignatureId;
        task.isReadOnly = previousReadOnly;
        alert('Failed to sign off the task. Please try again.');
      }
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // Everything the page needs in one call. entriesOnly skips the parts that don't change
    // after an edit (trainee, product, evaluations, chapters)
    async fetchPageData(entriesOnly = false) {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = localStorage.getItem('logbook_id');
      const params = entriesOnly ? { only: 'entries' } : {};

      const { data } = await axios.get(`/api/trainee/logbooks/${logbookId}/page`, { headers, params });

      this.logbook = data.logbook;
      this.logbookName = data.logbook.name;
      this.locked = data.logbook.locked;
      this.tasks = data.tasks || [];
      this.logbookEntries = data.entries || [];
      this.notes = data.notes || [];
      this.instructors = data.instructors || [];
      this.signatures = data.signatures || [];
      this.lastKnownUpdate = data.last_updated;

      if (!entriesOnly) {
        this.trainee = data.trainee || [];
        this.trainee_evaluations = data.evaluations || [];
        this.chapters = data.chapters || [];
        if (data.product) {
          this.currentProduct = data.product;
          localStorage.setItem('currentProduct', JSON.stringify(data.product));
        }
      }

      this.MTCount = this.tasks.filter(task => task.manob === 'MT').length;

      this.mergeData();
    },
    async fetchData() {
      try {
        await this.fetchPageData(true);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },

    // Lightweight poll: ask the server for a single timestamp representing the
    // latest change to this logbook (entries/notes/lock state). Only pulls the
    // full logbook data (4 requests) when that timestamp has actually moved on,
    // instead of unconditionally refetching everything on a timer.
    // Poll a single lightweight "has anything changed" endpoint every 60s
    // instead of unconditionally refetching the whole logbook. Skipped while
    // the tab isn't visible; visibility regain triggers an immediate check.
    startPolling() {
      if (this.refreshInterval) return;
      this.refreshInterval = setInterval(() => {
        if (!document.hidden) {
          this.checkForUpdates();
        }
      }, 60000);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    stopPolling() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    async checkForUpdates() {
      const logbookId = localStorage.getItem('logbook_id');

      // Safety net: never keep polling once the page is gone or there's no logbook (e.g. after logout)
      if (this.isUnmounted || !logbookId || logbookId === 'null') {
        this.stopPolling();
        return;
      }

      if (this.isCheckingForUpdates) return; // don't stack overlapping checks
      this.isCheckingForUpdates = true;

      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.get(`/api/logbooks/${logbookId}/last-updated`, { headers });
        const latest = response.data.last_updated;

        if (latest && latest !== this.lastKnownUpdate) {
          await this.fetchData();
          this.lastKnownUpdate = latest;
        }
      } catch (error) {
        console.error('Error checking for logbook updates:', error);
      } finally {
        this.isCheckingForUpdates = false;
      }
    },

    // Record the timestamp of a change we just made ourselves, so the next
    // lightweight poll doesn't mistake our own update for a remote one and
    // trigger a redundant full refetch.
    noteOwnChange(timestamp) {
      if (!timestamp) return;
      if (!this.lastKnownUpdate || new Date(timestamp) > new Date(this.lastKnownUpdate)) {
        this.lastKnownUpdate = timestamp;
      }
    },

    handleVisibilityChange() {
      if (!document.hidden) {
        // Tab just became active again - catch up immediately rather than
        // waiting for the next timer tick.
        this.checkForUpdates();
      }
    },

    mergeData() {
      const logbookEntries = this.logbookEntries || [];
      const instructors = this.instructors || [];
      const notes = this.notes || [];
      const tasks = this.tasks || [];
      this.mergedTasks = tasks.map(task => {
        const matchingEntry = logbookEntries.find(entry => entry.task_id === task.task_id);
        const matchingInstructor = instructors.find(
          instructor => instructor.user_id === matchingEntry?.instructor_id
        );
        const matchingEnabledInstructor = instructors.find(
          instructor => instructor.user_id === matchingEntry?.ins_enabled_id
        );
        const matchingNotes = notes.filter(
          note => note.logbookentry_id === matchingEntry?.id
        );
        return {
          ...task,
          logbookentry_id: matchingEntry ? matchingEntry.id : null,
          completed: matchingEntry ? matchingEntry.completed : null,
          ins_so: matchingEntry ? matchingEntry.ins_so : null,
          selected_date: matchingEntry ? matchingEntry.selected_date : null,
          enabled: matchingEntry ? matchingEntry.enabled === 1 : 0,
          ins_enabled_id: matchingEntry ? matchingEntry.ins_enabled_id : null,
          instructor_id: matchingEntry ? matchingEntry.instructor_id : null,
          is_selected: matchingEntry ? matchingEntry.is_selected : null,
          is_revoked: matchingEntry ? matchingEntry.is_revoked : null,
          t_signature_id: matchingEntry ? matchingEntry.t_signature_id : null,
          ins_signature_id: matchingEntry ? matchingEntry.ins_signature_id : null,
          ac_reg: matchingEntry ? (matchingEntry.ac_reg ?? matchingEntry.initial_ac_reg ?? '') : '',
          jobcard_no: matchingEntry ? matchingEntry.jobcard_no : null,
          entry_P1: matchingEntry ? matchingEntry.entry_P1 === 1 : 0,
          entry_P2: matchingEntry ? matchingEntry.entry_P2 === 1 : 0,
          instructor_enabled_name: matchingEnabledInstructor
            ? `${matchingEnabledInstructor.last_name}, ${matchingEnabledInstructor.first_name}`
            : '',
          instructor_name: matchingInstructor
            ? `${matchingInstructor.last_name}, ${matchingInstructor.first_name}`
            : '',
          instructor_license: matchingInstructor ? matchingInstructor.license_no : '',
          notes: matchingNotes,
        };
      });
      this.completedMTCount = this.mergedTasks.filter(task => task.manob === 'MT' && task.ins_so).length;
      console.log('merged', this.mergedTasks);
    },
    async openEditor(logbookEntryId, isPublic = false) {
      // Update the current task ID
      this.currentLogbookEntryId = logbookEntryId;
      this.isNotePublic = isPublic;  // Set the note type

      if (this.isNotePublic) {
        this.noteType = 'public'
      } else {
        this.noteType = 'private'
      }

      this.showQuillEditor = true;
    },
    closeQuillEditor() {
      this.showQuillEditor = false;
      this.fetchData();
    },
    async openChooseAssessmentModal() {
      this.showChooseAssessmentModal = true;
    },
    closeChooseAssessmentModal() {
      this.showChooseAssessmentModal = false;
      this.fetchData();
    },
    closeTaskAssessmentModal() {
      this.showTaskAssessmentModal = false;
      this.fetchData();
    },
    openTaskLongFormModal(task) {
      this.currentTaskId = task.task_id;
      this.showTaskLongFormModal = true;
    },
    closeTaskLongFormModal() {
      this.showTaskLongFormModal = false;
    },
    openTraineeProgressModal() {
      this.showTraineeProgressModal = true;
    },
    closeTraineeProgressModal() {
      this.showTraineeProgressModal = false;
    },
    openLogbookRulesModal() {
      this.showLogbookRulesModal = true;
    },
    closeLogbookRulesModal() {
      this.showLogbookRulesModal = false;
    },
    async closeSignatureModal() {
      this.showSignatureModal = false;
      // Refresh signatures (one may have just been added) before addSigToTasks relies on them
      await this.fetchData();
      this.addSigToTasks();

      const pendingTaskId = this.pendingSignOffTaskId;
      this.pendingSignOffTaskId = null;
      if (pendingTaskId !== null && this.findSelectedSignatureForUser(parseInt(localStorage.getItem('user_id')))) {
        const task = this.mergedTasks.find(t => t.task_id === pendingTaskId);
        if (task) this.confirmSignOff(task);
      }
    },
    openSignatureModal(event) {
      try {
        this.showSignatureModal = true;
      } catch (error) {
        console.error('Error opening signature modal:', error);
        // If `error` is actually an Event object, this will help surface more info.
        console.error('Event details:', event);
      }
    },
    confirmSignOff(task) {
      if (!this.user_id) {
        console.error("Attempt to sign off without user_id.");
        return;  // Prevent signing off without a user_id
      }
      // if (task.ac_reg === null || task.ac_reg === '') {
      //   alert('The AC registration is missing. Please update it before signing off.');
      //   return;
      // }
      // if (task.jobcard_no === null || task.jobcard_no === '') {
      //   alert('The Jobcard Number is missing. Please update it before signing off.');
      //   return;
      // }
      if (!task.entry_P1 && !task.entry_P2) {
        alert('Please select either P1 or P2 before signing off.');
        return;
      }
      if (!this.findSelectedSignatureForUser(parseInt(localStorage.getItem('user_id')))) {
        // Open the signature modal in place; closeSignatureModal resumes the sign-off once one is saved
        this.pendingSignOffTaskId = task.task_id;
        this.showSignatureModal = true;
        return;
      }
      if (confirm('Are you sure you want to sign off?')) {
        this.setTimestamp(task);
        //window.location.reload();
      }
    },
    fetchEvaluationData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = this.logbookId;

      axios.get(`/api/evaluations/logbooks/${logbookId}`, { headers })
        .then(response => {
          console.log('evaluations response:', response.data);

          if (Array.isArray(response.data)) {
            this.trainee_evaluations = response.data;
          } else if (Array.isArray(response.data?.data)) {
            this.trainee_evaluations = response.data.data;
          } else if (response.data) {
            this.trainee_evaluations = [response.data];
          } else {
            this.trainee_evaluations = [];
          }
        })
        .catch(error => {
          console.error('There was an error fetching the evaluation:', error);
          this.trainee_evaluations = [];
        });
    },
    openChooseEvaluationModal() {
      this.showChooseEvaluationModal = true;
      this.tasksCount = this.MTCount;
      this.tasksCompleted = this.completedMTCount || 0;
    },
    closeChooseEvaluationModal() {
      this.showChooseEvaluationModal = false;
      this.fetchEvaluationData();
    },
openRevokeSignOffModal(task) {
  console.log('task', task);
  this.currentTaskId = task.task_id;
  this.logbookentryId = task.logbookentry_id;
  this.signOff = task.completed;
  this.showRevokeSignOffModal = true;
},
closeRevokeSignOffModal() {
  this.showRevokeSignOffModal = false;
  this.fetchData();
},
  },
  async mounted() {
    this.user_id = localStorage.getItem('user_id');  // Retrieve and store user_id
    if (!this.user_id) {
      console.error("user_id not found");
      return;  // Handle the absence of user_id appropriately
    }
    // One call for the whole page. It also returns the freshness baseline
    // (last_updated) the polling below compares against.
    try {
      await this.fetchPageData();
    } catch (error) {
      console.error('An error occurred while fetching logbook data:', error);
    }

    // The user may have left the page while the data was loading
    if (this.isUnmounted) return;

    this.startPolling();
  },
  beforeUnmount() {
    this.isUnmounted = true;
    this.stopPolling();
  },
}

</script>

<style scoped>
.data-table-trainee .module,
.data-table-trainee .level,
.data-table-trainee .location,
.data-table-trainee .scope
 {
  width: 2%;
  /* adjust as needed */
}

.data-table-trainee .P1
{
  width: 1%;
}

.tee-pagination-button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  margin-bottom: 0px;
  z-index: 0;
  margin-top: 10px;
}

img {
  width: 100%;
  height: 30%;
  border: 1px solid lightgray;
}

.signature-container,
.ins-signature-container {
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000;
}

.ins-signature-image,
.signature-image {
  width: 100%;
  height: 100%;
}


.ac-reg-container {
  position: relative;
}

.ac-reg-suggestions {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
}

.ac-reg-suggestions li {
  padding: 8px;
  cursor: pointer;
}

.ac-reg-suggestions li:hover {
  background-color: #f0f0f0;
}

.jobcard-no-container {
  position: relative;
}

.jobcard-no-suggestions {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  width: 100%;
  list-style-type: none;
  padding: 0;
  margin: 0;
  z-index: 1000;
}

.jobcard-no-suggestions li {
  padding: 8px;
  cursor: pointer;
}

.jobcard-no-suggestions li:hover {
  background-color: #f0f0f0;
}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
  margin-left: 20px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.chapter-name-cell {
  background-color: rgba(38, 65, 116, 0.884);
  border: 1px solid rgb(2, 23, 63);
  color: white;
  text-align: center;
  
}

.traineepdfButton {
  border-radius: 5px;
  width: 150px;
  background-color: #a52c0d;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #491204;
  float: right;
}
.traineepdfButton:hover {
  background-color: #791e08;
}

.addSigButton {
  margin-right: 20px;
  border-radius: 5px;
  width: 200px;
  background-color: #6890ff;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #395192;
}

.addSigButton:hover {
  background-color: #395192;
}

.addSigButton:disabled {
  background-color: grey;
  cursor: not-allowed;
}

.flex-grow-1 {
  max-height: 40px;
}
</style>